module.exports = __webpack_public_path__ + "img/premium-car-used-car-image.847b867b.jpg";